export default __webpack_public_path__ + "static/media/selectDestinationValeVerde.12bd47d1.svg";